import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from "../pages/Aboutus/About";
import AddressPage from "../pages/Address/AddressPage";
import ForgotEmail from "../pages/Auth/ForgotEmail";
import ForgotPasswordOtp from "../pages/Auth/ForgotPasswordOtp";
import Login from "../pages/Auth/Login";
import NewPassword from "../pages/Auth/NewPassword";
import Signup from "../pages/Auth/Signup";
import BlogDetails from "../pages/Blog/BlogDetails";
import BlogPage from "../pages/Blog/BlogPage";
import ProductCart from "../pages/Cart/ProductCart";
import Checkout from "../pages/Checkout/Checkout";
import Contact from "../pages/Contact/Contact";
import Faq from "../pages/Faqs/Faq";
import Home from "../pages/Home/Home";
import MyOrder from "../pages/Order/MyOrder";
import Cookie from "../pages/Policy/Cookie";
import Privacy from "../pages/Policy/Privacy";
import Refund from "../pages/Policy/Refund";
import TermCondition from "../pages/Policy/TermCondition";
import AllProductPage from "../pages/ProductPage/AllProductPage";
import HotDeals from "../pages/ProductPage/HotDeals";
import NewArrivals from "../pages/ProductPage/NewArrivals";
import ProductDetails from "../pages/ProductPage/ProductDetails";
import ProductPage from "../pages/ProductPage/ProductPage";
import Profile from "../pages/Profile/Profile";
import ShippingInfo from "../pages/Shipping/ShippingInfo";
import WishList from "../pages/WishList/WishList";
import ProtectedRoutes from "./ProtectedRoutes";

function PublicRoutes() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="contact" element={<Contact />} />
          <Route path="aboutus" element={<About />} />
          <Route path="all-product-page" element={<AllProductPage />} /> 
          <Route path="products/:Id" element={<ProductPage />} />
          <Route path="products/:Id/:slug" element={<ProductPage />} />
          <Route path="hotdeals" element={<HotDeals />} />
          <Route path="newarrivals" element={<NewArrivals />} />

          <Route path="productdetails/:id" element={<ProductDetails />} />

          <Route path="blog" element={<BlogPage />} />
          <Route path="blogdetail/:id" element={<BlogDetails />} />
          <Route path="faqs" element={<Faq />} />
          <Route path="privacy-policy" element={<Privacy />} />
          <Route path="refund-policy" element={<Refund />} />
          <Route path="cookie-policy" element={<Cookie />} />
          <Route path="term-condition" element={<TermCondition />} />

          <Route path="wishlist" element={<WishList />} />
          <Route path="cart" element={<ProductCart />} />
          <Route path="checkout" element={<Checkout />} />

          <Route path="signup" element={<Signup />} />
          <Route path="signin" element={<Login />} />
          <Route path="forgot" element={<ForgotEmail />} />
          <Route path="forgot-password-Otp" element={<ForgotPasswordOtp />} />
          <Route path="new-password" element={<NewPassword />} />

          <Route path="/" element={<ProtectedRoutes />}>
            <Route path="profile" element={<Profile />} />
            <Route path="my-orders" element={<MyOrder />} />
            <Route path="address-page" element={<AddressPage />} />
            <Route path="shippinginfo" element={<ShippingInfo />} />
          </Route>
   
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default PublicRoutes;
